import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    uploadReferenceVideoSuccess,
    uploadReferenceVideoFailure
} from '../../actions/CreateCampaignActions/uploadReferenceVideoActions';

function* uploadReferenceVideoWorker({ payload, callback }) {
    try {
        const formData = new FormData();
        formData.append('file', payload.file);

        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.uploadReferenceGuidanceVideo,
            payload: formData,
            isAuth: true,
            ContentType: 'multipart/form-data',
        });

        yield put(
            uploadReferenceVideoSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );

        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            );
        }
    } catch (error) {
        yield put(
            uploadReferenceVideoFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
        if (callback) {
            callback(error?.response?.data?.status || 500, null, error?.response?.data?.message || 'Upload failed');
        }
    }
}

function* uploadReferenceVideoSaga() {
    yield takeLatest(actionTypes.UPLOAD_REFERENCE_VIDEO_REQUEST, uploadReferenceVideoWorker);
}

export default uploadReferenceVideoSaga;
